<template>
    <NavItem class="dropdown">
        <NavItemLink class="navbar-nav-link dropdown-toggle legitRipple" :is-dropdown-toggle="true">
            <img :src="languages[currentLanguage].flag" class="img-flag mr-2" alt="">
            {{ languages[currentLanguage].name }}
        </NavItemLink>
        <DropDownMenu class="dropdown-menu-right">
            <slot v-for="(language, locale) in languages">
                <TextDropDownMenuItem @click="changeLanguage(locale)" v-if="currentLanguage !== locale" >
                    <img :src="language.flag" class="img-flag" alt=""> {{ language.name }}
                </TextDropDownMenuItem>
            </slot>
        </DropDownMenu>
    </NavItem>
</template>
<script>
import NavItem from "../../../../components/navbar/AppNavItem.vue";
import NavItemLink from "../../../../components/navbar/AppNavItemLink.vue";
import DropDownMenu from "../../../../components/dropdown/AppDropDownMenu.vue";
import TextDropDownMenuItem from "../../../../components/dropdown/TextDropDownMenuItem.vue";

export default {
    name: 'LanguageTab',
    components: {
        NavItem, NavItemLink, DropDownMenu, TextDropDownMenuItem
    },
    data() {
        return {
            languages: {
                en: {
                    name: 'English',
                    flag: '/limitless/global_assets/images/lang/en.png',
                },
                uk: {
                    name: 'Українська',
                    flag: '/limitless/global_assets/images/lang/uk.png',
                }
            }
        }
    },
    methods: {
        changeLanguage(locale) {
            this.$i18n.locale = locale;
        }
    },
    computed: {
        currentLanguage() {
            return this.$i18n.locale;
        }
    }
}
</script>